import { ReactNode } from 'react'

import i18n from 'modules/core/lib/i18n'

import FixFlowStep from './FixFlowStep'

class RoleLevelSalaryStep extends FixFlowStep {
  constructor(component: ReactNode) {
    super(
      i18n.t('contract_versions.flows.fix.steps.role_level_salary.title'),
      component,
      i18n.t('contract_versions.flows.fix.steps.role_level_salary.description')
    )
  }
}

export default RoleLevelSalaryStep
